import { SpriteConstant } from './../../../constant/sprite.constant';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { UtilService } from 'src/app/util/UtilService';

@Component({
    templateUrl: '../../../template/noop.template.html',
    standalone: false
})
export class PlayForFunAlertLayoutComponent implements OnInit, OnChanges {
  private resizeTimeOut;
  @Input() data: any;
  @Input() lobbyLoadingInsideViasino = false;
  @Input() currentLanguage = 'en';
  @Input() userCurrency: any = 'USD';
  @Input() funUserBalance: any;
  @Input() userBalance: any;
  @Input() gameTypeRealOrFunOption: any;
  @Input() inSufficientFund: boolean = false;
  @Input() funGameNotAvailable: boolean = false;
  activePlayType: any;
  currencySymbol: string;
  public state;
  @Output() eventEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() tableDetailsEventEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() tableLivecasinoEventEmit: EventEmitter<any> =
    new EventEmitter<any>();
  betLimits: any;

  _subscriptionScale;

  public contentWidth = 0;
  public contentHeight = 0;

  common_icons: any;
  menu_icons: any;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }
  constructor(public _utilService: UtilService) {
    this.setContentHeight();
    this._subscriptionScale = _utilService.scaleChange.subscribe((value) => {
      // console.log('_subKKKKKKscriptionScale');
      this.resizeTimeOut = setTimeout(() => {
        this.setContentHeight();
        window.clearTimeout(this.resizeTimeOut);
        delete this.resizeTimeOut;
      }, 300);
    });
  }

  setContentHeight = () => {
    //console.log('setContentHeight setContentHeight setContentHeight setContentHeight');
    this.contentWidth = window.screen.availWidth;
    this.contentHeight =
      this._utilService.parentHeight != 0
        ? this._utilService.parentHeight
        : window.innerHeight;
  };

  ngOnInit() {
    this.betLimits = this.data.betLimits;
    this.init();
  }

  ngOnChanges(changeData) {
    if (changeData.data) {
      this.data = changeData.data.currentValue;
      this.init();
    }

    if (changeData.funUserBalance) {
      this.funUserBalance = changeData.funUserBalance.currentValue;
    }
  }

  init() {
    this.common_icons = SpriteConstant.COMMON_ICONS;
    this.menu_icons = SpriteConstant.MENU_ICONS;
  }

  buttonOverOrOut(value) {
    //console.log("buttonOverOrOut",value);
    this.activePlayType = value;
  }

  buttonClick(value) {
    //console.log("buttonClick",value);
    this.activePlayType = value;
    //this.eventEmit.emit(value);
    let betLimitsSelection = this.gameTypeRealOrFunOption;
    //TODO this.gameTypeRealOrFunOption example
    /*{
      "inSufficientFund": true,
      "isGameTypeRealOrFunPopUpEnable": true,
      "gameName": "fc21",
      "gameFeatureName": "private",
      "betLimitId": "8",
      "seatAvailable": "5",
      "newtable": 0
      "tableIndex": 1
    }*/
    betLimitsSelection.activePlayType = this.activePlayType;
    //console.log("betLimitsSelection.betLimitId",betLimitsSelection,betLimitsSelection.betLimitId);

    this.tableDetailsEventEmit.emit(betLimitsSelection);
  }

  onCloseClick = (event = null) => {
    this.eventEmit.emit(event);
  };
  ngOnDestroy() {
    if (this.resizeTimeOut) {
      window.clearTimeout(this.resizeTimeOut);
    }
    if (this._subscriptionScale) {
      this._subscriptionScale.unsubscribe();
    }
    delete this._subscriptionScale;
    delete this.resizeTimeOut;
    delete this.data;
    delete this.lobbyLoadingInsideViasino;
    delete this.currentLanguage;
    delete this.userCurrency;
    delete this.funUserBalance;
    delete this.userBalance;
    delete this.gameTypeRealOrFunOption;
    delete this.inSufficientFund;
    delete this.funGameNotAvailable;
  }
}
